export default "/images/0c113d5d3b641fb345f413ee5fb5d723.avif";